import { createBrowserRouter } from 'react-router';

import { App } from './App';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
    children: [
      {
        index: true,
        lazy: async () => {
          const mod = await import('./routes/Home');
          return { Component: mod.Home };
        },
      },
      {
        path: 'add',
        lazy: async () => {
          const mod = await import('./routes/AddBook');
          return { Component: mod.AddBook };
        },
      },
      {
        path: 'books/:id',
        lazy: async () => {
          const mod = await import('./routes/BookPage');
          return { Component: mod.BookPage };
        },
      },
      {
        path: 'import',
        lazy: async () => {
          const mod = await import('./routes/Import');
          return { Component: mod.Import };
        },
      },
      {
        path: 'year',
        lazy: async () => {
          const mod = await import('./routes/YearReview');
          return { Component: mod.YearReview };
        },
      },
      {
        path: 'backup',
        lazy: async () => {
          const mod = await import('./routes/Backup');
          return { Component: mod.Backup };
        },
      },
      {
        path: 'privacy',
        lazy: async () => {
          const mod = await import('./routes/Privacy');
          return { Component: mod.Privacy };
        },
      },
      {
        path: '*',
        lazy: async () => {
          const mod = await import('./routes/NotFound');
          return { Component: mod.NotFound };
        },
      },
    ],
  },
]);
